import { Text, YStack } from '@frontend/web-react';
import { NavLinkWrapper } from '@frontend/web/components';
import { useAnalytics } from '@frontend/web/hooks/useAnalytics';

type CalendarRecurrencesBannerProps = {
  eventCount: number;
};

export const CalendarRecurrencesBanner = ({ eventCount }: CalendarRecurrencesBannerProps) => {
  const { track } = useAnalytics();

  const handleClick = () => {
    track({
      event: 'selectedFindRepeatingTasksBanner',
      topic: 'tasks',
    });
  };

  return (
    <NavLinkWrapper
      className="bg-navy-100 gap-sm py-md pl-md relative flex flex-row overflow-hidden rounded-lg"
      onClick={handleClick}
      to="/app/calendar-recurrence"
    >
      <YStack className="grow-1 flex flex-col gap-sm">
        <Text type="h5">You have {eventCount} repeating events on your calendar.</Text>
        <Text className="text-navy-600" type="p-sm">
          Convert your repeated events to repeated tasks in Duckbill now
        </Text>
      </YStack>
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <YStack className="bg-surfaceBrand p-sm absolute -top-1 right-[-20px] w-[150px] rotate-[30deg] items-center justify-center pl-[40px]">
        <Text className="text-textAccent text-center" type="captionBold" uppercase>
          JUST DUCK IT
        </Text>
      </YStack>
    </NavLinkWrapper>
  );
};
